import {computed, observable} from "mobx";

/**
 * This class acts as a wrapper for a string that
 * represents the path to a photo.
 *
 */
export class Photo {
  @observable photo;

  private static photoVariant(photo, variant) {
    if(photo) {
      const lastSlash = photo.lastIndexOf("/");
      if (-1 !== lastSlash) {
        return photo.substring(0, lastSlash) + variant + photo.substring(lastSlash);
      }
    }
    return null;
  }

  @computed get icon() {
    if (this.photoIsJPG || this.photoIsPNG) {
      return Photo.photoVariant(this.photo, ICON_VARIANT);
    } else {
      return this.photo;
    }
  }

  @computed get smallPhoto(){
    if (this.photoIsJPG) {
      return Photo.photoVariant(this.photo, SMALL_VARIANT);
    } else {
      return this.photo;
    }
  }

  @computed get photoIsSVG() {
    return (this.photo && this.photo.trim().indexOf(PHOTO_TYPE.SVG) == this.photo.length - PHOTO_TYPE.SVG.length);
  }

  @computed get photoIsPNG() {
    return (this.photo && this.photo.trim().indexOf(PHOTO_TYPE.PNG) == this.photo.length - PHOTO_TYPE.PNG.length);
  }

  @computed get photoIsJPG() {
    return (this.photo && (this.photo.trim().indexOf(PHOTO_TYPE.JPG) == this.photo.length - PHOTO_TYPE.JPG.length || this.photo.trim().indexOf(PHOTO_TYPE.JPEG) == this.photo.length - PHOTO_TYPE.JPEG.length));
  }



  constructor(photo:string|null) {
    this.photo = photo;
  }

}


const PHOTO_TYPE = {
  SVG:'.svg',
  JPG:'.jpg',
  JPEG:'.jpeg',
  PNG:'.png',
}

const ICON_VARIANT = '/icons';
const SMALL_VARIANT = '/smalls';
